<template>
  <div class="box5">
    <div class="logo">
      <img src="../assets/素材/logo2.png" alt="" />
    </div>
    <div @click="nativeShare" v-if="shareShow" class="share">
      <img src="../assets/素材/分享 (5).png" alt="" />
    </div>
    <div class="Restaurant">{{RestaurantName}}</div>
    <div class="box2">
      <div class="filst">尊敬的贵宾</div>
      <div class="message">
        <div class="time">{{ time1 }} {{ time2 }}</div>
        <!-- {{ invitee }}<br /> -->
        <div class="message2" v-for="(item, index) in message" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="address">
        <p><span>联系人：</span>{{ linkman }}</p>
        <p><span>联系电话：</span>{{ phone }}</p>
        <p><span>地址：</span>{{ address2 }}</p>
        <div @click="map(address)" class="navigation">
          <img src="../assets/素材/导航 (1).png" alt="" />
          <span>导航</span>
        </div>
      </div>
      <div class="swiper">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in imgs" :key="index">
            <img :src="item" alt="" style="width: 100%; height: 100%" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <van-action-sheet v-model="sheetShow" :actions="[{ name: '高德地图' }, { name: '百度地图' }, { name: '腾讯地图' }]" @select="onSelect2" />
    
  <!-- <baidu-map :center="center" :zoom="zoom" @ready="handler" style="width: 60%;height: 250px;"></baidu-map> -->
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// import BMap from 'baidu-map'
import NativeShare from 'nativeshare'
import wx from "weixin-js-sdk";
import dayjs from "dayjs";
const axios = require('axios');

export default {
  data() {
    return {
      imgs: [],
      data: {},
      appid: 'wx15087d322e1c12ab',
      position: [],
      showShare: false,
      shareShow: true,
      invitee: "",
      time1: "",
      time2: "",
      time3: "",
      time4: "",
      msg: "",
      message: "",
      RestaurantTitle: "",
      RestaurantName: "",
      sheetShow: false,
      address: "",
      address2: "",
      linkman: "",
      phone: "",
      RestaurantId: "",
      userId: "",
      center: {lng: 0, lat: 0},
      zoom: 15,
      options: [
        { name: '微信', icon: 'wechat' },
      ],
      AMapLoader: {
            key: "4958410c31f1e970fc69161faba4264d", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            /*

            AMap.Geocoder 地理编码与逆地理编码

            AMap.Geolocation 高德基于浏览器API的定位插件

            */
            plugins: ["AMap.Geolocation", "AMap.Geocoder"], // 需要使用的插件列表，所有的插件都在这里配置
          },

          //地图绘制参数

          parameter: {
            zoom: 11, //级别

            viewMode: "3D", //使用3D视图

            resizeEnable: true,

            enableHighAccuracy: true, //是否使用高精度定位，默认:true

            convert: true,

          },
    }
  },
  created() {
    this.userId = this.$route.query.id
    const ua = navigator.userAgent.toLowerCase();  
    if (ua.match(/MicroMessenger/i) == "micromessenger") {  
      // 当前环境是微信  
      console.log("This is WeChat environment.");
      this.shareShow = false
      // 在这里可以执行微信环境下的特定代码  
    } else {  
      // 当前环境不是微信  
      console.log("This is NOT WeChat environment.");
      this.shareShow = true
    }
  },
  mounted() {
    this.getInvitationLetterByID(this.userId)
    let data = JSON.stringify({
          "uri": `https://il.jichedi.net/` // 当前页面url
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://kit.jichedi.net/api/v1/wechat/get-config',
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data),66666);
          this.getInvitationLetterByID(this.userId)
          this.data = response.data.data;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
              appId: this.data.appId, // 必填，公众号的唯一标识
              timestamp: this.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: this.data.nonceStr, // 必填，生成签名的随机串
              signature: this.data.signature,// 必填，签名
              jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareWeibo',
              'onMenuShareQZone',
              'startRecord',
              'stopRecord',
              'onVoiceRecordEnd',
              'playVoice',
              'pauseVoice',
              'stopVoice',
              'onVoicePlayEnd',
              'uploadVoice',
              'downloadVoice',
              'chooseImage',
              'previewImage',
              'uploadImage',
              'downloadImage',
              'translateVoice',
              'getNetworkType',
              'openLocation',
              'getLocation',
              'hideOptionMenu',
              'showOptionMenu',
              'hideMenuItems',
              'showMenuItems',
              'hideAllNonBaseMenuItem',
              'showAllNonBaseMenuItem',
              'closeWindow',
              'scanQRCode',
              'openProductSpecificView',
              'addCard',
              'chooseCard',
              'openCard'
              ], // 必填，需要使用的JS接口列表
          });
            const that = this;
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
              console.log(that.time1,that.time2,that.userId)
              wx.updateAppMessageShareData({
                title: '用餐邀请', // 分享标题
                desc: that.time4 + ' ' +that.time3 +'\n'+that.RestaurantName+'诚挚邀请您的光临!', // 分享描述
                link: `https://il.jichedi.net/#/invite?id=${that.userId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: that.imgs[0], // 分享图标
                success: function () {
                  // 设置成功
                  console.log(111)
                },        
              })
              // 监听微信 JS-SDK 的全局错误事件  
              wx.error(function (res) {  
                // 任何其他错误都会触发这里  
                console.log('微信 JS-SDK 错误:', res);
              });  
            });
        })
        .catch((error) => {
          console.log(error);
        });
        /* 注意 : 【高德的所有API都需要再load回调里面进行书写 需要用到返回值AMap 否则都会报错】  */
        AMapLoader.load(this.AMapLoader).then((AMap) => {
          //存储实例地图
          console.log(AMap)
          // this.map = new AMap.Map("container", this.parameter);

          //实例逆向转码

          const Geocoder = new AMap.Geocoder();
          console.log(Geocoder)
          Geocoder.getLocation(this.address, (status, result) => {
            console.log('Geocoder status:', status);
            console.log('Geocoder result:', result);
          if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
            const position = result.geocodes[0].location; // 这应该是一个包含lng和lat的对象
            console.log(position)
            this.position.push(position.lng)
            this.position.push(position.lat)
          }
        })

          // this.map.on("click", function (e) {
          //   console.log(e, "点击地图获取位置");

          // });

          // this.map.plugin("AMap.Geolocation", () => {
          //   const geolocation = new AMap.Geolocation({
          //     enableHighAccuracy: true, //是否使用高精度定位，默认:true

          //     timeout: 10000, //超过10秒后停止定位，默认：无穷大

          //     maximumAge: 0, //定位结果缓存0毫秒，默认：0

          //     convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true

          //     showButton: true, //显示定位按钮，默认：true

          //     buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角

          //     showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true

          //     showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true

          //     panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true

          //     zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false

          //   });

          //   geolocation.getCurrentPosition(function (status, result) {
          //     if (status == "complete") {
          //       //授权成功获取的经纬度

          //       const {
          //         position: { lng, lat },

          //       } = result;

          //       console.log(lng,lat);

          //     }

          //   });

          // });

        });       
      },
  methods: {
    map() {
      this.sheetShow = true
      this.position = []
      AMapLoader.load(this.AMapLoader).then((AMap) => {
          //存储实例地图
          console.log(AMap)
          const Geocoder = new AMap.Geocoder();
          console.log(Geocoder)
          Geocoder.getLocation(this.address, (status, result) => {
            console.log('Geocoder status:', status);
            console.log('Geocoder result:', result);
          if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
            const position = result.geocodes[0].location; // 这应该是一个包含lng和lat的对象
            console.log(position)
            this.position.push(position.lng)
            this.position.push(position.lat)
          }
        })
        });
      console.log(this.position,111)
      // AMap.plugin('AMap.Geocoder', function() {
      //   const geocoder = new AMap.Geocoder({
      //     // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
      //     city: '010'
      //   })

      //   geocoder.getLocation('北京市海淀区苏州街', function(status, result) {
      //     if (status === 'complete' && result.info === 'OK') {
      //       // result中对应详细地理坐标信息
      //       const position = result.position; // 这应该是一个包含lng和lat的对象
      //       const url = `https://uri.amap.com/marker?position=${position.lng},${position.lat}&name=湖岸`;
      //       window.location.href = url;
      //     }
      //   })
      // })
      // window.location.href = `https://uri.amap.com/marker?position=${this.position[0]},${this.position[1]}&name=${name}`
    },
    // handler ({BMap, map}) {
    //   console.log(BMap, map)
    //   this.center.lng = 116.404
    //   this.center.lat = 39.915
    //   this.zoom = 15
    // },
    onSelect2(item) {
      console.log(this.position[0],this.position[1])
      if(item.name == '高德地图') {
        window.location.href = `https://uri.amap.com/marker?position=${this.position[0]},${this.position[1]}&name=${this.address}`
      }else if(item.name == '百度地图') {
        // window.location.href = `http://api.map.baidu.com/geocoder?address=${this.address}&output=html&src=webapp.baidu.openAPIdemo`
        window.location.href = `http://api.map.baidu.com/marker?location=${this.position[1]},${this.position[0]}&title=${this.address}&coord_type=gcj02&output=html&src=webapp.baidu.openAPIdemo`
        // window.location.href = `http://api.map.baidu.com/place/detail?uid=2fd2beabe34a80517adbd220&output=html&src=webapp.baidu.openAPIdemo //调起百度PC或Web地图`
      }else {
        window.location.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.position[1]},${this.position[0]};title:${this.address};addr:${this.address}&referer=myapp`
      }
      this.sheetShow = false;
    },
    async getInvitationLetterByID (id) {
      const result = await this.$baseUrl.collection("invitation_letter").getOne(id);
      this.invitee = result.invitee
      this.RestaurantId = result.restaurant
      this.getRestaurantById(this.RestaurantId)
      const magList = result.letter_content.split("\n");
      // this.msg = magList[0]
      this.message = magList;
      const data = result.invited_at.replace(/\.\d+Z$/, '');
      const arr = data.split(' ');
      let date = new Date(arr[0]);
      // 获取星期几的数值，并转换为字符串
      let dayOfWeek = '星期'+['日', '一', '二', '三', '四', '五', '六'][dayjs(date).day()];
      // function getWeekdayInChinese(date) {  
      //     return date.toLocaleString('zh-CN', { weekday: 'long' });  
      // }         
      // const weekday = getWeekdayInChinese(date);  
      // console.log(weekday);
      const time = arr[0]
      this.time4 = arr[0]
      const year = time.split('-')[0]+'年'
      const month = time.split('-')[1]+'月'
      const day = time.split('-')[2]+'日'
      this.time1 = year+month+day;
      this.time2 = dayOfWeek + ' ' + arr[1].slice(0, -3);
      // this.time3 = arr[1]
      this.time3 = arr[1].slice(0, -3);
      // alert(date+'/'+dayjs(date).day()+dayOfWeek)
      
    },

    async getRestaurantById(RestaurantId){
      const result = await this.$baseUrl.collection("restaurant").getOne(RestaurantId);
      console.log(result,22222);
      this.RestaurantName = result.title
      this.address = result.province + result.city + result.district + result.address
      this.address2 = result.city + result.district + result.address
      this.linkman = result.contact_person
      this.phone = result.contact_phone
      const img = result.photos
      const options = {}
      this.imgs = []
      img.forEach(item => {
        const url = this.$baseUrl.files.getUrl(result, item, options);
        this.imgs.push(url)
      })
      
    },
    // async getRestaurants() {
    //   const list = await this.$baseUrl.collection("restaurant").getFullList();
    //   list = list.filter(item => item.id == this.RestaurantId)   
    //   this.RestaurantTitle = list[list.length-1].title
    //   this.address = list[list.length-1].province + list[list.length-1].city + list[list.length-1].district + list[list.length-1].address
    //   this.linkman = list[list.length-1].contact_person
    //   this.phone = list[list.length-1].contact_phone
    //   const img = list[list.length-1].photos
    //   const options = {}
    //   img.forEach(item => {
    //     const url = this.$baseUrl.files.getUrl(list[list.length-1], item, options);
    //     this.imgs.push(url)
    //   })
    // },
    onSelect(option) {
      console.log(option)
      this.showShare = false;
    },
    // nativeShare() {
    //   const that = this;
    //   wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    //     console.log(that.time1,that.time2,that.userId)
    //     wx.updateAppMessageShareData({
    //       title: '用餐邀请', // 分享标题
    //       desc: that.time1+that.time2+'\n'+that.RestaurantTitle+'诚挚邀请您的光临!', // 分享描述
    //       link: `https://il.jichedi.net/#/invite?id=${that.userId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl: this.imgs[0] || '', // 分享图标
    //       success: function () {
    //         // 设置成功
    //         console.log(111)
    //       },        
    //     })
    //     // 监听微信 JS-SDK 的全局错误事件  
    //     wx.error(function (res) {  
    //       // 任何其他错误都会触发这里  
    //       console.log('微信 JS-SDK 错误:', res);  
    //     });  
    //   });
    // },
    nativeShare() {
      let nativeShare = new NativeShare()
      nativeShare.setShareData({
        title: '用餐邀请', // 分享标题
        desc: `${this.time4+' '} ${this.time3+' '+' '}\n${this.RestaurantName}诚挚邀请您的光临!`, // 分享描述
        link: `https://il.jichedi.net/#/invite?id=${this.userId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        icon: this.imgs[0], // 分享图标
        success: function () {
          console.log('success')
        },
        fail: function () {
          console.log('fail')
        }
      })
      try {
        nativeShare.call('default')//
        // 如果是分享到微信则需要 nativeShare.call('wechatFriend')
        // 类似的命令有
        //  default 默认，调用起底部的分享组件，当其他命令不支持的时候也会调用该命令
        //  wechatTimeline 分享到朋友圈
        //  wechatFriend 分享给微信好友
        //  qqFriend 分享给QQ好友
        //  qZone 分享到QQ空间
        //  weibo 分享到微博
        console.log('成功')
      } catch (err) {
        // 如果不支持，你可以在这里做降级处理
        console.log('失败')
      }
    }
  }
}
</script>

<style>
img {
  width: 100%;
}
.box5 {
  position: relative;
  padding-top: 341px;
  background-image: url("../assets/素材/封面v3.jpg");
  background-size: 100% 100%;
}
.logo {
  position: absolute;
  top: 36px;
  left: 36px;
  /* width: 137px;
  height: 36px; */
  width: 213px;
  height: 56px;
}
.share {
  position: absolute;
  top: 46px;
  right: 36px;
  width: 45px;
  height: 45px;
}
.logo img .share img {
  width: 100%;
  height: 100%;
}
.box2 {
  /* position: absolute;
  top: 578px; */
  padding-top: 37px;
  padding-bottom: 290px;
  width: 100%;
  text-align: center;
}
.time {
  /* position: absolute; */
  /* top: 578px; */
  width: 100%;
  text-align: center;
  color: rgb(170, 128, 92);
  font-size: 32px;
  margin-bottom: 42px;
}
.message {
  margin-top: 42px;
  margin-bottom: 106px;
  font-family: 'FZXBS';
}
.message,
.message .message2 {
  width: 100%;
  text-align: center;
  color: rgb(170, 128, 92);
  font-size: 32px;
  line-height: 60px;
}
.message .message2 {
  width: 680px;
  margin: 0 auto;
  overflow-wrap: break-word;
  letter-spacing: 3px; /* 增加字符间距像素 */
}
.filst {
  text-align: center;
  color: rgb(105, 105, 105);
  font-size: 40px;
  letter-spacing: 5px; /* 增加字符间距像素 */
}
.address {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.address p {
  width: 100%;
  box-sizing: border-box;
  margin-top: 15px;
  font-size: 26px;
  color: rgb(105, 105, 105);
  padding: 0 30px;
}
.address p span {
  color: rgb(170, 128, 92);
}
.navigation {
  width: 126px;
  height: 54px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: rgb(170, 128, 92);
}
.navigation img {
  width: 30px;
  height: 30px;
}
.navigation span {
  color: rgb(255, 255, 255);
  font-size: 24px;
}
.swiper {
  /* position: absolute;
  left: 0;
  bottom: 250px; */
  margin-top: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-swipe {
  width: 563px !important;
  height: 375px !important;
}
.van-share-sheet__title {
  font-size: 26px !important;
}
.van-share-sheet__icon {
  width: 72px !important;
  height: 72px !important;
}
.van-share-sheet__name {
  font-size: 22px;
}
.van-share-sheet__cancel {
  height: 110px !important;
  line-height: 95px !important;
  font-size: 26px !important;
}
.Restaurant {
  width: 100%;
  /* position: absolute;
  left: 0; */
  /* margin-top: 341px; */
  background: linear-gradient(122.33deg, rgb(197, 163, 121),rgb(242, 217, 183),rgb(197, 163, 121));
  -webkit-background-clip:
  text;
  -webkit-text-fill-color:
  transparent;
  background-clip:
  text;
  text-fill-color:
  transparent;
  font-family: 'FZMH';
  font-size: 130px;
  font-weight: 400;
  line-height: 154%;
  letter-spacing: -5%;
  text-align: center;
}
.van-action-sheet__item {
  font-size: 28px;
  padding: 40px;
}
</style>
